import React from 'react';

export const citCheckinCashReplenishmentConfig = [
  {
    path: '/checkin',
    component: React.lazy(() => import('./cit/listing/listing')),
  },
  {
    path: '/checkin/acceptance',
    component: React.lazy(() => import('./cit/acceptance/detail')),
  },
  {
    path: '/checkin/overview-checkin',
    component: React.lazy(() => import('./cit/checkIn/detail')),
  },
  {
    path: '/checkin/confirmation-repair',
    component: React.lazy(() => import('./cit/confirmation/detail')),
  },
];
